import { useState } from 'react'

export default function useFileDownload() {
    const [downloadingFile, setDownloadingFile] = useState(false)
    const [error, setError] = useState(null)

    const downloadFile = async (url, fileName) => {
        if(!url) return
        return new Promise(async (resolve, reject) => {
            try {
                setDownloadingFile(true)
                setError(null)

                const response = await fetch(url)
                if (!response.ok) throw new Error('Download failed')

                const blob = await response.blob()
                const downloadUrl = window.URL.createObjectURL(blob)
                
                const link = document.createElement('a')
                link.href = downloadUrl
                
                // Extract file extension from URL
                const defaultName = url.split('/').pop() // Get last segment of URL
                const extension = defaultName.includes('.') ? defaultName.split('.').pop() : ''
                
                // Add extension to fileName if it doesn't already have one
                const finalFileName = fileName && !fileName.includes('.') ? `${fileName}.${extension}` : fileName || defaultName
                link.download = finalFileName
                
                
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                
                window.URL.revokeObjectURL(downloadUrl)
                resolve(true)
                setDownloadingFile(false)
            } catch (err) {
                setError(err.message)
                reject(err)
            } 
        })
    }

    return {
        downloadFile,
        downloadingFile,

    }
}
